import { EmbeddedMessageMedium, MessageMedium } from 'constants/messageMediums';
import { NODE_TYPES } from '../nodes';

type MediumOrNodeType = string | MessageMedium;
type MessageMediumNodeTypeMap = Record<MediumOrNodeType, MediumOrNodeType>;

// Enum-like map of medium to node type and vice versa
export const MESSAGE_MEDIUM_NODE_TYPE_MAP: MessageMediumNodeTypeMap = Object.entries({
  [MessageMedium.Email]: NODE_TYPES.SEND_EMAIL,
  [MessageMedium.InApp]: NODE_TYPES.SEND_IN_APP,
  [MessageMedium.Push]: NODE_TYPES.SEND_PUSH,
  [MessageMedium.SMS]: NODE_TYPES.SEND_SMS,
  [MessageMedium.WebPush]: NODE_TYPES.SEND_WEB_PUSH,
  [EmbeddedMessageMedium.Embedded]: NODE_TYPES.SEND_EMBEDDED,
} as Record<MessageMedium, string>).reduce(
  (acc, [key, value]) => ({ ...acc, [key]: value, [value]: key }),
  {} as MessageMediumNodeTypeMap,
);
